interface PartnerResponsibleUser {
  id: number
  name: string
  avatar?: string | null
  email?: string | null
  working_phone?: string | null
}

interface PartnerResponsibleType {
  id: number
  name: string
  display_name: string
}

export interface PartnerResponsible {
  id: number
  responsible_type_id: number
  created_at?: string
  user: PartnerResponsibleUser
  responsible_type?: PartnerResponsibleType
}

export interface GetPartnerResponsiblesResponse {
  data: PartnerResponsible[] | null
  code: number
}
